import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { api, formatEventDate } from "../lib/api";
import Seo from "../components/Seo";

const EventsList = () => {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(({ data }) => setEvents(data)); }, []);
  return (
    <main className="grain min-h-screen" data-testid="events-list-page">
      <Seo
        path="/events"
        title="All events"
        description="Browse upcoming and recent FintechOmni events for performance marketers in fintech. Las Vegas, Miami, New York, San Juan."
        keywords="fintech events, fintech conferences, fintech marketing summit, las vegas fintech, miami fintech, new york fintech, san juan fintech"
      />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-20 pb-24">
        <div className="term-label mb-3">/ index</div>
        <h1 className="font-display font-black tracking-tighter text-5xl sm:text-7xl">All events.</h1>
        <p className="text-white/60 mt-4 max-w-xl">Browse upcoming and recent FintechOmni gatherings. Tap any event to see the agenda and RSVP.</p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {events.map((e) => (
            <Link key={e.id} to={`/events/${e.slug}`} className="group hard-border bg-cyber-surface overflow-hidden" data-testid={`evt-${e.slug}`}>
              {e.hero_image && (
                <div className="aspect-video overflow-hidden">
                  <img src={e.hero_image} alt={e.title} className="w-full h-full object-cover img-grey" />
                </div>
              )}
              <div className="p-6">
                <div className="term-label">{e.date_tbd ? "Date TBD" : formatEventDate(e.date)} · {e.city}</div>
                <h3 className="font-display font-black tracking-tighter text-2xl mt-2 group-hover:text-cyber-yellow transition-colors duration-150">{e.title}</h3>
                <p className="text-white/60 mt-2 text-sm line-clamp-2">{e.tagline}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="font-mono-tech text-xs text-cyber-green tracking-[0.2em] uppercase">{e.rsvp_active === false ? "Notify me →" : "Request Invitation →"}</span>
                  <ArrowUpRight size={18} className="text-cyber-yellow group-hover:rotate-45 transition-transform duration-150" weight="bold" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
};

export default EventsList;
